import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@ui/primitives/utils';
export const VisibilityTag = (param)=>{
    let { label, className } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: cn('flex max-h-6 items-center rounded border border-border bg-secondary px-3 py-0.5 text-center leading-[1.4rem]', className),
        "data-e2e": "project-item-visibility-tag",
        children: /*#__PURE__*/ _jsx("p", {
            className: "text-xs capitalize text-muted-foreground",
            children: label
        })
    });
};
